// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:28
import { ActionConditionGroup_abstract } from './../abstract/SagaActionLib/ActionConditionGroup_abstract';
export class ActionConditionGroup extends ActionConditionGroup_abstract {}
